import { Children, isValidElement } from 'react'
import { trim } from 'lodash-es'

import type { ReactNode } from 'react'

interface ExtractTextNodesOptions {
  translate?: (descriptor: {
    id: string
    message?: ReactNode
    values?: Record<string, ReactNode>
  }) => ReactNode
}

function normalizeTextNode(text: string) {
  return trim(text.replace(/<\/?\d+\s*\/?>/g, '').replace(/\s+/g, ' '))
}

export function extractTextNodes(
  children: ReactNode,
  options: ExtractTextNodesOptions = {},
): string[] {
  const textNodes: string[] = []
  Children.forEach(children, (child) => {
    if (isValidElement(child)) {
      if (options.translate && typeof child.props.id === 'string') {
        textNodes.push(
          ...extractTextNodes(
            options.translate({
              id: child.props.id,
              message: child.props.message,
              values: child.props.values,
            }),
            options,
          ),
        )
        return
      }

      // Some compiled i18n elements keep their text in `message` instead of `children`.
      const nestedChildren = child.props.children ?? child.props.message

      if (nestedChildren !== undefined && nestedChildren !== null) {
        textNodes.push(...extractTextNodes(nestedChildren, options))
      }
    } else if (typeof child === 'string' || typeof child === 'number') {
      const normalizedChild = normalizeTextNode(String(child))

      if (normalizedChild) {
        textNodes.push(normalizedChild)
      }
    }
  })
  return textNodes
}
